import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useApolloClient } from "@apollo/client";
import { IconLoader2, IconAlertCircle } from "@tabler/icons-react";
import { cpExchangePreviewToken } from "_graphql/mutations";
import "./Preview.scss";

function Preview({ onAuthenticated }) {
  const client = useApolloClient();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(null);
  const [exchanging, setExchanging] = useState(true);

  useEffect(() => {
    const exchangeToken = async () => {
      const previewToken = searchParams.get("token");

      if (!previewToken) {
        setError("No preview token provided.");
        setExchanging(false);
        return;
      }

      try {
        const result = await client.mutate({
          mutation: cpExchangePreviewToken,
          variables: { preview_token: previewToken },
        });

        const response = result?.data?.cpExchangePreviewToken;

        if (response?.success && response?.token) {
          // Clear any existing session data
          localStorage.removeItem("ADMIN_JWT");
          
          // Store the new customer token
          localStorage.setItem("JWT", response.token);
          
          // Force a full page reload to clear all cached data (Apollo cache, React state, etc.)
          // This ensures we don't have stale data from a previous preview session
          window.location.href = `/${response.application_id}`;
        } else {
          setError(response?.error || "Failed to exchange preview token.");
          setExchanging(false);
        }
      } catch (err) {
        console.error("Preview token exchange error:", err);
        setError("An error occurred. Please try again.");
        setExchanging(false);
      }
    };

    exchangeToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (error) {
    return (
      <div className="preview-container">
        <div className="preview-card">
          <div className="preview-error">
            <IconAlertCircle size={48} />
            <h2>Preview Error</h2>
            <p>{error}</p>
            <button 
              className="preview-home-button"
              onClick={() => navigate("/", { replace: true })}
            >
              Go to Home
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="preview-container">
      <div className="preview-card">
        <IconLoader2 
          className="preview-spinner" 
          size={48} 
        />
        <h2>Loading Preview...</h2>
        <p>Please wait while we set up your preview session.</p>
      </div>
    </div>
  );
}

export default Preview;

